import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { httpsCallable } from "firebase/functions";
import { functions } from "../constants/firebase";
import { ROUTES } from "../App";

const VerifyPaystackPayment = () => {
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const reference = params.get("reference") || localStorage.getItem("paystack_ref");
        const productId = params.get("productId");
        const type = params.get("type");
        const jobId = params.get("jobId");
        const creatorId = params.get("creatorId");

        if (reference) {
            verifyPaystackPayment({ reference, productId, type, jobId, creatorId });
        } else {
            console.error("No payment reference found.");
            window.showToast?.("No payment reference found.", "error");
        }
    }, [location]);

    const verifyPaystackPayment = async ({ reference, productId, type, jobId, creatorId }) => {
        try {
            const verifyAndProcess = httpsCallable(functions, "verifyAndProcessPaystackPayment");
            await verifyAndProcess({
                reference,
                type: type || (productId ? "product_purchase" : jobId ? "job_secure" : null),
                productId: productId || null,
                jobId: jobId || null,
                creatorId: creatorId || null,
            });

            if (type === "job_secure") {
                window.showToast?.("Job secured successfully!", "success");
                window.location.replace(`/#${ROUTES.JOBS_MY_POSTS}?hire=success`);
            } else {
                window.showToast?.("Payment successful!", "success");
                window.location.replace(`/#${ROUTES.PRODUCT_DETAILS}/${productId}?purchase=success`);
            }
        } catch (err) {
            console.error("Verification error:", err);
            const msg = err?.message || "Payment verification failed. Please contact support.";
            window.showToast?.(msg, "error");
            if (productId) {
                window.location.replace(`/#${ROUTES.PRODUCT_DETAILS}/${productId}?purchase=failed`);
            }
        }
    };

    return (
        <div className="flex justify-center items-center min-h-screen">
            <h2>Verifying your payment, please wait...</h2>
        </div>
    );
};

export default VerifyPaystackPayment;
